import { createFileRoute } from '@tanstack/react-router';
import { RelatorioCadastroRelacaoClientes } from '@/features/relatorio/page/cadastro/relacao-clientes/RelatorioCadastroRelacaoClientes';

export const Route = createFileRoute('/a/relatorio/cadastro/relacao-clientes')({
    component: RelatorioCadastroRelacaoClientes,
});
